import { render, staticRenderFns } from "./TreeselectInfoOption.ts.vue?vue&type=template&id=65f17e97&%23option-label=%7B%20node%2C%20labelClassName%20%7D"
import script from "./TreeselectInfoOption.ts.vue?vue&type=script&lang=ts&setup=true"
export * from "./TreeselectInfoOption.ts.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./TreeselectInfoOption.ts.vue?vue&type=style&index=0&id=65f17e97&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports